//**************************************************************
// 0. scroll fadein animation
//**************************************************************
$(window).scroll(function () {
  $('.fadeInUp').each(function() {
    var elemPos = $(this).offset().top,
      scroll = $(window).scrollTop(),
      windowHeight = $(window).height();

    if (scroll > elemPos - windowHeight + 100) {
      $(this).addClass('scrollin');
    }
  });
});


//**************************************************************
// 2. Scroll ※topを離れたらclass付与
//**************************************************************
function init() {
  // スクロールして何ピクセルでアニメーションさせるか
  var px_change   = 200;

  // スクロールのイベントハンドラを登録　ヘッダーにクラス名 smaller を付与
  window.addEventListener('scroll', function(e){
    // 変化するポイントまでスクロールしたらクラスを追加
    if ( $(window).scrollTop() > px_change ) {
      $('header').addClass('smaller');

    // 変化するポイント以前であればクラスを削除
    } else if ( $('header').hasClass('smaller') ) {
      $('header').removeClass('smaller');
      $('#header-nav').removeAttr('checked').prop('checked', false).change();  // topでpull down用のcheckを外す
    }
  });
}
window.onload = init();



//**********************************************************************
// 3. Parallax scroll
//**********************************************************************
$(function() {
    $(window).scroll(function(){
        var scroll = $(this).scrollTop(); // スクロール値を取得
        // console.info(scroll);
        $('.scroll_bg01').css('top', parseInt( -scroll / 20 + 50) + 'px'); // 1/5のスピード
        // $('.scroll_bg02').css('top', parseInt( -scroll / 25 + 35) + '%'); // 1/5のスピード
        // $('.scroll_bg03').css('top', parseInt( -scroll / 30 + 80) + '%'); // 1/5のスピード
        // $('.scroll_bg01').css('background-position', '5px ' + parseInt( -scroll / 10 ) + 'px'); // 1/5のスピード
        // $('.scroll_bg01').css(
        //   'background-position', '0% ' + parseInt( -scroll / 5 + 100) + 'px,' + '100% ' + parseInt( -scroll / 5 + 1000) + 'px,' + '10% ' + parseInt( -scroll / 8 + 2000) + 'px, ' + '105% ' + parseInt( -scroll / 8 + 3500) + 'px'
        // ); // 1/xのスピード
    });
});


//**********************************************************************
// 4. ハンバーガーメニューのアンカークリック後に 閉じる
//**********************************************************************
$(function() {
    $('.modal-close').on('click', function(event) {
        $('#sp-modal-nav').prop('checked', false);
    });
});



//**************************************************************
// メニュー　領域外をクリックしたら閉じる
//**************************************************************
jQuery(document).ready(function($) {
  var nav = $('.navbar-collapse');
  $('.main-section').click(function() {
   //ここでnavの部分がactiveクラスを持っているか確認
    if(nav.hasClass('show')) {
      $('.navbar-collapse').removeClass('show');
    }
  });
});
